import * as React from "react";
import getConfig from "next/config";
import { CmsHeadTags, CmsComponentSlot, isPreviewMode, getReturnReasons } from "@grandvisionhq/bloomreach";
import { Components, Pages, Operations, Types } from "@grandvisionhq/fun-returns";
import { useIntl } from "@grandvisionhq/state";
import { LocaleUtils } from "@grandvisionhq/utils";
import { e as errorResponse, g as getQueryParams } from "../../error-response.js";
const { publicRuntimeConfig } = getConfig();
const PageLayout = (props) => /* @__PURE__ */ React.createElement(Pages.PageLayout, { bottomContainerSlot: /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" }) }, /* @__PURE__ */ React.createElement(Pages.SelectItemsPage, { ...props }));
const Page = (props) => {
  const { getLabel } = useIntl();
  if (props.redirect) {
    return /* @__PURE__ */ React.createElement(
      Components.RedirectionWrapper,
      {
        email: props.email,
        orderNumber: props.orderNumber,
        redirect: props.redirect
      }
    );
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    CmsHeadTags,
    {
      title: getLabel("returns.page.selectItems.title"),
      noFollow: true,
      noIndex: true
    }
  ), /* @__PURE__ */ React.createElement(PageLayout, { ...props }));
};
Page.getInitialProps = async (context) => {
  const {
    apolloClient,
    pathname,
    req,
    query,
    asPath,
    pageModel,
    featureToggles: {
      featureConfigs: { bloomreachRefPrefix }
    }
  } = context;
  const defaultLocale = publicRuntimeConfig.defaultLocale;
  const locale = req ? LocaleUtils.getLocale(req, defaultLocale, false) : defaultLocale;
  const preview = isPreviewMode(query);
  if (!apolloClient) {
    console.error(`ApolloClient not present in context for page ${pathname}`);
    return errorResponse();
  }
  const { email, orderNumber } = getQueryParams(
    query,
    asPath,
    ["email", "orderNumber"]
  );
  if (preview) {
    return {};
  } else if (!email || !orderNumber) {
    return {
      redirect: {
        reason: "missingCredentials",
        page: "login"
      }
    };
  }
  const { data: returnData, failures } = await Operations.ReturnQueryService.getForSelectItems({
    client: apolloClient,
    email,
    orderNumber,
    locale
  });
  const hasFailures = !!failures?.length;
  const isReturnRequested = returnData?.status === Types.ReturnStatus.RETURN_REQUESTED;
  const isReturnable = returnData?.status === Types.ReturnStatus.RETURNABLE;
  if (hasFailures) {
    return {
      redirect: {
        reason: failures[0],
        page: "login"
      }
    };
  }
  if (isReturnRequested) {
    return {
      email,
      orderNumber,
      redirect: {
        page: "confirmation"
      }
    };
  }
  if (isReturnable) {
    const returnReasons = getReturnReasons(pageModel, bloomreachRefPrefix);
    return {
      lineItems: returnData.lineItems ?? void 0,
      returnReasons,
      orderNumber,
      email
    };
  }
  return {
    redirect: {
      reason: "unknownError",
      page: "login"
    }
  };
};
export {
  Page
};
//# sourceMappingURL=select-items.js.map
